import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Box } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import CloseIcon from '@material-ui/icons/Close';
import UploadIcon from '../../../../../assets/icons/upload-cloud.svg';
import PDFIcon from '../../../../../assets/icons/pdf-icon.svg';
import PPTIcon from '../../../../../assets/icons/pptIcon.png';
import imageIcon from '../../../../../assets/icons/imageIcon.png';
import docIcon from '../../../../../assets/icons/docIcon.png';
import Button from '../../../../../materialUi/btn';


export default function UploadDialog({
  open, setOpen, handleCancel, handleSubmit, data,
}) {
  const [localFiles, setLocalFiles] = React.useState([]);
  const [filesToSave, setFilesToSave] = React.useState([]);
  const [errorMessage, setErrorMessage] = React.useState('');

  const validateFileSize = (files) => {
    for (let i = 0; i < files.length; i++) {
      if (files[i].size > 100000000) {
        setErrorMessage('File size too large! Please, select a file smaller than 100MB');
        return false;
      }
    }
    return true;
  };

  const validateFileFormat = (files) => {
    for (let i = 0; i < files.length; i++) {
      if (files[i].type !== 'application/msword'
      && files[i].type !== 'application/pdf'
      && files[i].type !== 'application/vnd.ms-powerpoint'
      && files[i].type !== 'image/png'
      && files[i].type !== 'image/jpeg'
      && files[i].type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      && files[i].type !== 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
      ) {
        setErrorMessage('Files must be in .pdf, .doc, .docx, .pptx, .png or .jpeg format');
        return false;
      }
    }
    return true;
  };

  // const formatString = (string) => string.toString().toLowerCase().trim().replace(' ', '');

  // const validateDuplicatedFile = (files) => {
  //   if (data.taxReturnFiles.length === 0) return true;
  //   let result = true;
  //   data.taxReturnFiles.map((file) => {
  //     if (formatString(files[0].name) === formatString(file.fileName || file.name)) {
  //       result = false;
  //     }
  //     return file;
  //   });
  //   if (!result) setErrorMessage('File already selected.');
  //   return result;
  // };


  const sendFile = (event) => {
    const { files } = event.target;
    if (validateFileSize(files) && validateFileFormat(files)) {
      const joinedFiles = [...localFiles, ...files];
      setFilesToSave(joinedFiles);
      setLocalFiles(joinedFiles);
      data.taxReturnFiles = joinedFiles;
      setErrorMessage('');
    }
  };

  const handleSend = () => {
    handleSubmit(filesToSave);
  };

  const renderIconBasedOnDocType = (item) => {
    if (item.type === 'application/msword' || item.fileType === '.doc' || item.fileType === '.docx') {
      return docIcon;
    } if (item.type === 'application/pdf' || item.fileType === '.pdf') {
      return PDFIcon;
    } if (item.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || item.fileType === '.pptx') {
      return PPTIcon;
    }
    return imageIcon;
  };

  const deleteFile = (index) => {
    localFiles.splice(index, 1);
    setFilesToSave(Array.from(localFiles));
    setLocalFiles(Array.from(localFiles));
  };

  React.useEffect(() => {
    setLocalFiles(data.taxReturnFiles);
  }, [data.taxReturnFiles, localFiles]);


  return (
    <Dialog
      open={open}
      onClose={setOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="Upload dialog, upload your documents by selecting the documents and click on submit."
      fullWidth
      maxWidth="sm"
    >
      <h1 className="upload-dialog-title">
        Upload File and Images
      </h1>
      <DialogContent>
        <button
          type="button"
          className="upload-dialog-close"
          onClick={setOpen}
        >
          <CloseIcon />
        </button>
        <DialogContentText id="alert-dialog-description">
          <Grid container className="upload-dialog-box">
            <Grid item xs={12} align="center">
              <img src={UploadIcon} alt="upload icon" />
            </Grid>
            <Grid item xs={12} align="center">
              <h2 className="upload-dialog-box-title">
                File Upload
              </h2>
              <div>
                <button
                  tabIndex="0"
                  type="button"
                  className="upload-dialog-upload-button"
                >
                  CHOOSE FILE
                  <input
                    id="myFileInput"
                    name="taxReturnFiles"
                    type="file"
                    accept="image/*;capture=camera"
                    className="upload-dialog-input-button"
                    multiple
                    onChange={sendFile}
                  />
                </button>
              </div>
              <div className="custom-error mt-3">
                {errorMessage}
              </div>
              <h4 className="upload-dialog-box-description">
                Files must be in .pdf, .doc, .docx, .pptx, .png or .jpeg format. Max 100MB.
              </h4>
            </Grid>
          </Grid>
          <Grid container>
            {localFiles && localFiles.length > 0 && localFiles.map((item, index) => (
              <Box className="upload-dialog-document" key={item.name}>
                <img
                  src={renderIconBasedOnDocType(item)}
                  alt="PDF icon"
                  width="25px"
                  height="25px"
                />
                <span className="upload-dialog-document-text">
                  {item.name || item.fileName}
                  <button
                    type="button"
                    className="upload-dialog-remove-file"
                    onClick={() => deleteFile(index)}
                  >
                    <CloseIcon fontSize="small" />
                  </button>
                </span>
              </Box>
            ))}
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ padding: '8px 24px' }}>
        <Box style={{ marginRight: '10px' }}>
          <Button
            label="Cancel"
            bgColor="white"
            color="#E76F51"
            bgColorHover="#E76F51"
            colorHover="white"
            borderColor="#E76F51"
            variant="outlined"
            width={128}
            onClick={handleCancel}
            type="button"
          />
        </Box>
        <Button
          label="Add Files"
          bgColor="#e76f50"
          color="white"
          colorHover="white"
          bgColorHover="#ff8c68"
          width={128}
          onClick={handleSend}
          type="submit"
        />
      </DialogActions>
    </Dialog>
  );
}

UploadDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  data: PropTypes.shape(
    {
      taxReturnFiles: PropTypes.arrayOf(PropTypes.any),
    },
  ).isRequired,
};
